import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
      webUsers: [],
      mobileUsers: [],
      activates: [],
      bonuses:[],

  },
  actions,
  mutations,
  getters
}
